import styled from "styled-components";

export const ReportContainer = styled.div`
  display: block;
  @media (max-width: 850px) {
    display: none;
  }
`;

export const MobileFB = styled.div`
  display: none;
  @media (max-width: 850px) {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 34px 35px;
    /* button {
      background: transparent;
      border: 0.5px solid #000;
      box-shadow: 0px 10px 25px rgba(211, 190, 159, 0.5);
      color: #000;
      border-radius: 6px;
      max-width: 320px;
      width: 100%;
      height: 40px;
      &.active {
        color: #ffffff;
        background: linear-gradient(90deg, #bc9b6a 9.9%, #947550 100%);
        border: 0.5px solid #ffffff;
        box-shadow: 0px 10px 25px rgba(211, 190, 159, 0.5);
      }
    } */
    .MuiFormControlLabel-root {
      border: 1px solid #cdcfd0;
      border-radius: 6px;
      padding-right: 10px;
      position: relative;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 0;
      min-height: 40px;
    }
    .MuiFormControlLabel-label {
      position: relative;
      background: transparent;
      padding: 5px;
      font-weight: 500;
      font-size: 14px;
      line-height: 150.5%;
      color: #fff;
    }
    .MuiButtonBase-root {
      /* background: gray; */
      background-color: gray !important;

      position: absolute;
      /* z-index: 1;
      visibility: hidden; */
      width: 100%;
      border-radius: 6px;
      height: 100%;
      color: #000;
      svg {
        opacity: 0;
      }
      &.Mui-checked {
        background: linear-gradient(
          90deg,
          #bc9b6a 9.9%,
          #947550 100%
        ) !important;
        /* border: 0.5px solid #ffffff; */
        box-shadow: 0px 10px 25px rgba(211, 190, 159, 0.5);
      }
    }
  }
`;

export const FilterHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 28px;
  background: var(--filter-bar-bg);
  flex-wrap: wrap;
  row-gap: 10px;
  .label-wrapper {
    display: flex;
    align-items: center;
    border-right: 1px solid #cdcfd0;
    padding: 0 15px;
    gap: 15px;
    .MuiInputBase-input {
      font-size: 13px;
      line-height: 150%;
      padding: 6px 10px;
    }
    .MuiInputBase-root {
      max-width: 150px;
      background: #ffffff;
      border-radius: 6px;
    }
    label {
      font-size: 13px;
      line-height: 16px;
      white-space: nowrap;
      color: var(--theme-text);
    }
  }
  .filter-btn-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0 15px;
    flex-wrap: wrap;
    button {
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 13px;
      border: 1px solid var(--filter-bar-btn-border);
      border-radius: 30px;
      background-color: transparent;
      min-height: 30px;
      color: var(--theme-text);
      min-width: 31px;
      justify-content: center;
      padding: 0 15px;
      :disabled {
        opacity: 0.5;
      }
      .active {
        background: #bc9b6a;
      }
    }
  }
  .refresh-btn {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 13px;
    border: 1px solid var(--filter-bar-btn-border);
    border-radius: 30px;
    background-color: transparent;
    min-height: 30px;
    color: var(--theme-text);
    min-width: 31px;
    justify-content: center;
    padding: 0 15px;
    :disabled {
      opacity: 0.5;
    }
  }
`;

export const ChartMainWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  background: #fcfcfc;
  gap: 25px;
  padding: 30px;
  max-height: calc(100vh - 112px);
  overflow: auto;
  > div {
    background-color: #fff;
    box-shadow: 2px 4px 5px 2px rgba(0, 0, 0, 0.02);
  }
  @media (max-width: 850px) {
    grid-template-columns: 1fr;
  }
`;
